import { serialize, deserialize } from "wagmi";
import { QueryClient } from "@tanstack/react-query";
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";

export const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 1_000 * 60 * 60 * 24, // 24 hours
        networkMode: "offlineFirst",
        refetchOnWindowFocus: false,
        retry: 0,
      },
      mutations: { networkMode: "offlineFirst" },
    },
  });
  
export const persister = createSyncStoragePersister({
    key: "react.cache",
    serialize,
    storage: window.localStorage,
    deserialize,
  });